export const NAME = 'userSession'

export const ATTESTATIONS_POST = 'ATTESTIONS'
export const TERMS_AND_CONDITIONS_AGREED_POST = 'cartTermsandconditionsagreedPost'
export const PATCH_PROVIDER_SEARCH_CHECK = 'user-session:patchProviderSearchCheck()'
export const GET_MY_PROVIDERS = 'user-session:getProviders()'
export const ADD_TO_MY_PROVIDERS = 'user-session:addToProviders()'
export const REMOVE_FROM_MY_PROVIDERS = 'user-session:removeFromProviders()'
export const REMOVE_ALL_FROM_PROVIDER = 'user-session:removeFromAllProvider()'
export const GET_USER_BENEFITS = 'user-session:getBenefits()'
